import { render, staticRenderFns } from "./UnderClip.vue?vue&type=template&id=6a45730f&scoped=true"
import script from "./UnderClip.vue?vue&type=script&lang=js"
export * from "./UnderClip.vue?vue&type=script&lang=js"
import style0 from "./UnderClip.vue?vue&type=style&index=0&id=6a45730f&prod&lang=scss"
import style1 from "./UnderClip.vue?vue&type=style&index=1&id=6a45730f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a45730f",
  null
  
)

export default component.exports